<div class="min-h-screen dark:bg-zinc-950 pb-24 relative">
  <app-header class="fixed w-full h-full"
              *ngIf="isHeaderEnabled()"
              [ngStyle]="{ 'max-height': headerStyle() }"
  />
  <fv-snackbar #snackbar/>
  <fv-prompt #prompt/>
  <fv-confirm #confirm/>
  <fv-contextmenu #contextMenu/>
  <fv-actionsheet #actionSheet/>
  <fv-scanner #scanner/>
  <app-splashart-loader #splashArt/>
  <ng-template #globalDynamicModalContainer/>
  <app-change-delivered-modal class="absolute"/>
  <div class="bg-zinc-50 dark:bg-zinc-900 min-h-screen w-full z-20"
       [ngClass]="[headerStyle(), isScreenFixed()
       ? 'fixed md:!fixed lg:!fixed'
       : 'absolute']"
  >
    <router-outlet/>
    <app-quick-actions-widget *isDesktop/>
  </div>
</div>
